module.exports = __webpack_public_path__ + "static/media/trash-red-big.ebf5e0bd.svg";